import React, { useEffect } from "react";
import { Tooltip } from "antd";
import InfoIcon from "../../../../assets/Info_Icon.svg";
import { kFormatter } from "../../../../redux/constants";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsSelected,
  setAllSelectedCheckbox,
  setWidgetList,
} from "../../../../redux/actions/widget/widget";
const Header = ({
  data,
  id,
  BasicCharts,
  widgetsData,
  value,
  widgetName,
  widgetDec,
}) => {
  const dispatch = useDispatch();
  //checkbox
  const isSelected = useSelector((state) => state.Widget.isSelected);
  const widgetList = useSelector((state) => state.Widget.widgetList);
  const allSelectedCheckbox = useSelector(
    (state) => state.Widget.allSelectedCheckbox
  );
  //It formats big numbers by applying K

  const handleChecklist = (e, value, id) => {
    let arrList = [...widgetList];
    let select = { ...isSelected };

    if (value && e.target.id == id) {
      select[id] = value;
      dispatch(setIsSelected(select));
      //if checked and id matches then add widget
      let obj = {
        template_id: widgetsData?.template_id,
        widget_id: id,
        widget_name: widgetName,
        type: data?.type,
        description: data?.description,
        x_label: data?.x_label,
        y_label: data?.y_label,
        graph_type: data?.graph_type,
        y_range: data?.y_range,
        title: data?.title,
        stacked: data?.stacked,
        data: data?.data,
        number_data: data?.number_data,
      };

      arrList?.push(obj);
      dispatch(setWidgetList(arrList));
    } else if (!value) {
      select[id] = value;

      dispatch(setIsSelected(select));
      //if unchecked and id matches then remove widget
      arrList = widgetList?.filter((el) => {
        return el.widget_id !== id;
      });

      dispatch(setWidgetList(arrList));
    }
    if (allSelectedCheckbox && widgetsData?.length > arrList?.length) {
      dispatch(setAllSelectedCheckbox(false));
    }
  };
  useEffect(() => {
    if (isSelected[id] === undefined) {
      isSelected[id] = false;
    }
  }, [id]);
  return (
    <>
      {" "}
      <div className="border-bottom border-color p-15">
        <div className="portlet__title d-flex fontSize-16 font-weight500 align-items-center w-100">
          {BasicCharts && (
            <span
              className={`checklist ${
                widgetList &&
                widgetList?.findIndex((el) => el.widget_id === id) >= 0 &&
                isSelected[id]
                  ? "active"
                  : ""
              }`}
              id={id}
              onClick={(e) => handleChecklist(e, !isSelected[id], id)}
            >
              {widgetList &&
                widgetList?.findIndex((el) => el.widget_id === id) + 1}
            </span>
          )}
          <span className="mr-1 fontSize-16 font-weight600">
            {widgetName}
            {widgetDec && (
              <span className="font-size12 text-gray ml-1 font-weight400">
                ({widgetDec})
              </span>
            )}
            {id === "tickets_simple-view_2" && (
              <Tooltip
                title="This is the status distribution of tickets in selected duration."
                placement="bottom"
              >
                <img
                  src={InfoIcon}
                  alt="Info Icon"
                  className="ml-1 cursor-pointer"
                />
              </Tooltip>
            )}
            {id === "tickets_simple-view_6" && (
              <Tooltip
                title="This is the status distribution of tickets in the selected month"
                placement="bottom"
              >
                <img
                  src={InfoIcon}
                  alt="Info Icon"
                  className="ml-1 cursor-pointer"
                />
              </Tooltip>
            )}
          </span>
          <span className="mr-1 blue-text">
            <Tooltip
              title={data?.data ? data?.data[0]?.value?.toLocaleString() : ""}
            >
              {value && kFormatter(data?.data && data?.data[0]?.value)}
            </Tooltip>
          </span>
          <span
            className={`font-weight400 font-size12 ${
              value
                ? data?.data && data?.data[0]?.percent_change > 0
                  ? "positive"
                  : "error"
                : "d-none"
            }`}
          >
            {data?.data && data?.data[0]?.percent_change}%
            {data?.data && data?.data[0]?.percent_change > 0 ? (
              <i className="fa fa-caret-up ml-1" />
            ) : (
              <i className="fa fa-caret-down ml-1" />
            )}
          </span>
        </div>
      </div>
    </>
  );
};

export default Header;
